<template>
  <div ref="tab" class="invoice-box">
    <div class="invoice-headers" :class="'headers-background-'+invoiceInfo.applyStatus">
      <headers
        :headInfo="{headUrl: invoiceInfo.dingDingPhotoPath, dingdingUserId:invoiceInfo.currentApplyDingDingId, userName: invoiceInfo.currentApplyEmployeeName, approver: invoiceInfo.nextApprover, approvalState: invoiceInfo.applyStatus }"
      ></headers>
    </div>
    <div ref="invoice_tab" class="invoice-tab">
      <tab :tabconfig="tabconfig"></tab>
    </div>
    <div class="mian-box">
      <div class="invoice-info d_jump">
        <div class="invoice-content">
          <div class="invoice-info-box">
            <div class="invoice-info-label">开票项目</div>
            <div class="invoice-info-content">{{invoiceInfo.projectName}}</div>
          </div>
          <div class="invoice-info-box">
            <div class="invoice-info-label">开票金额</div>
            <div class="invoice-info-content">{{invoiceInfo.amount|NumFormat}}元</div>
          </div>
          <div class="invoice-info-box">
            <div class="invoice-info-label">开票公司</div>
            <div class="invoice-info-content">{{invoiceInfo.companyName}}</div>
          </div>
          <div class="invoice-info-box">
            <div class="invoice-info-label">收入项目</div>
            <div class="invoice-info-content">{{invoiceInfo.itemName}}</div>
          </div>
          <!--考核单元开始-->
          <div v-if="invoiceInfo.singleFinancial">
            <div class="invoice-info-box">
              <div class="invoice-info-label">考核单元</div>
              <div class="invoice-info-content">{{invoiceInfo.financialDept}}</div>
            </div>
          </div>
          <div v-else></div>
          <!--考核单元结束-->
          <div class="invoice-info-box">
            <div class="invoice-info-label">发票类型</div>
            <div class="invoice-info-content">{{invoiceInfo.invoiceTypeName}}</div>
          </div>
          <!--机动车发票开始-->
          <div v-if="invoiceInfo.typeID==1">
            <div class="invoice-info-box">
              <div class="invoice-info-label">客户全称</div>
              <div class="invoice-info-content">{{invoiceInfo.customerName}}</div>
            </div>
            <div class="invoice-info-box">
              <div class="invoice-info-label">身份证</div>
              <div class="invoice-info-content">{{invoiceInfo.iDNumber}}</div>
            </div>
            <div class="invoice-info-box">
              <div class="invoice-info-label">客户电话</div>
              <div class="invoice-info-content">{{invoiceInfo.customerTel}}</div>
            </div>
            <div class="invoice-info-box">
              <div class="invoice-info-label">车架号</div>
              <div class="invoice-info-content">{{invoiceInfo.vIN}}</div>
            </div>
            <div class="invoice-info-box">
              <div class="invoice-info-label">品牌型号</div>
              <div class="invoice-info-content">{{invoiceInfo.brandModel}}</div>
            </div>
          </div>
          <!--机动车发票结束-->
          <!--专票/普通票票开始-->
          <div v-if="invoiceInfo.typeID>1">
            <div class="invoice-info-box">
              <div class="invoice-info-label">开票单位</div>
              <div class="invoice-info-content">{{invoiceInfo.invoiceCompanyName}}</div>
            </div>
            <div class="invoice-info-box">
              <div class="invoice-info-label">纳税人识别号</div>
              <div class="invoice-info-content">{{invoiceInfo.taxNo}}</div>
            </div>
            <div class="invoice-info-box">
              <div class="invoice-info-label">开票地址</div>
              <div class="invoice-info-content">{{invoiceInfo.billingAddress}}</div>
            </div>
            <div class="invoice-info-box">
              <div class="invoice-info-label">联系电话</div>
              <div class="invoice-info-content">{{invoiceInfo.telNo}}</div>
            </div>
            <div class="invoice-info-box">
              <div class="invoice-info-label">开户行</div>
              <div class="invoice-info-content">{{invoiceInfo.bankName}}</div>
            </div>
            <div class="invoice-info-box">
              <div class="invoice-info-label">开户账号</div>
              <div class="invoice-info-content">{{invoiceInfo.bankAccount}}</div>
            </div>
            <div class="invoice-info-box">
              <div class="invoice-info-label">合同编号</div>
              <div class="invoice-info-content">{{invoiceInfo.contractID}}</div>
            </div>
            <div class="invoice-info-box">
              <div class="invoice-info-label">业务编号</div>
              <div class="invoice-info-content">{{invoiceInfo.contractNo}}</div>
            </div>
            <div class="invoice-info-box">
              <div class="invoice-info-label">合同名称</div>
              <div class="invoice-info-content">{{invoiceInfo.contractName}}</div>
            </div>
          </div>
          <!--专票/普通票票结束-->
          <div class="invoice-info-box">
            <div class="invoice-info-label">收件人</div>
            <div class="invoice-info-content">{{invoiceInfo.recipients}}</div>
          </div>
          <div class="invoice-info-box">
            <div class="invoice-info-label">收件电话</div>
            <div class="invoice-info-content">{{invoiceInfo.recipientTel}}</div>
          </div>
          <div class="invoice-info-box">
            <div class="invoice-info-label">发票邮寄地址</div>
            <div class="invoice-info-content">{{invoiceInfo.invoiceSendAddress}}</div>
          </div>
          <div class="invoice-info-box">
            <div class="invoice-info-label">快递单号</div>
            <div class="invoice-info-content">{{invoiceInfo.expressNo}}</div>
          </div>
          <div class="invoice-info-box">
            <div class="invoice-info-label">备注</div>
            <div
              class="invoice-info-content"
              v-html="$options.filters.textareaToFormat(invoiceInfo.remark)"
            ></div>
          </div>
          <div class="invoice-info-box">
            <div class="invoice-info-label">附件</div>
            <div class="invoice-info-content">
              <filebox message="暂无相关文档" :fileInfo="fileInfo"></filebox>
            </div>
          </div>
        </div>
        <div class="divide-line"></div>
        <div class="invoice-detail-content">
          <div class="invoice-detail-title">费用明细</div>
          <div class="invoice-detail-Total">
            总金额
            <span>{{detailTotal|NumFormat}}元</span>
          </div>
          <div v-for="(item,index) in invoiceInfo.detailsList" :key="index" class="tab-box">
            <div class="tab-box-item">
              <div class="tab-box-label">发票内容</div>
              <div class="tab-box-value">{{item.content}}</div>
            </div>
            <div v-if="item.brandModel&&item.brandModel!=''" class="tab-box-item">
              <div class="tab-box-label">品牌型号</div>
              <div class="tab-box-value">{{item.brandModel}}</div>
            </div>
            <div v-if="item.vIN&&item.vIN!=''" class="tab-box-item">
              <div class="tab-box-label">车架号</div>
              <div class="tab-box-value">{{item.vIN}}</div>
            </div>
            <div class="tab-box-item">
              <div class="tab-box-label">数量</div>
              <div class="tab-box-value">{{item.quantity}}</div>
              <div class="tab-box-label">金额</div>
              <div class="tab-box-value">{{item.amount|NumFormat}}元</div>
            </div>
          </div>
        </div>
        <div class="divide-line"></div>
      </div>
      <div class="process d_jump">
        <process
          :approvalList="invoiceInfo.approvalList"
          :applyEmployeeID="invoiceInfo.applyEmployeeID"
        ></process>
      </div>
    </div>
    <div class="invoice-foot">
      <exefoot
        :paramInfo="{...paramInfo,approveStep:invoiceInfo.nextApproveStep,isEnd:invoiceInfo.isLastApproval}"
        v-if="invoiceInfo.nextApproverId&&invoiceInfo.nextApproverId.indexOf(userInfo.employeeID)>-1&&invoiceInfo.applyStatus=='SUBMIT'"
      ></exefoot>
      <selffoot
        :paramInfo="paramInfo"
        :urgeInfo="{approverUserId:invoiceInfo.nextApproverUserId,applyEmployeeName:invoiceInfo.currentApplyEmployeeName, applyTypeName:'开票申请'}"
        v-else-if="invoiceInfo.applyEmployeeID==userInfo.employeeID&&invoiceInfo.applyStatus=='SUBMIT'"
      ></selffoot>
      <passfoot :paramInfo="paramInfo" v-else></passfoot>
    </div>
  </div>
</template>
<script>
import headers from "@/components/Approval/ApprovalHead/index";
import tab from "@/components/Share/Tab";
import order from "@/components/Share/Table/Order";
import process from "@/components/Approval/ApprovalProcess/index";
import exefoot from "@/components/Approval/ApprovalFoot/approvalExeFoot";
import selffoot from "@/components/Approval/ApprovalFoot/approvalSelfFoot";
import passfoot from "@/components/Approval/ApprovalFoot/approvalPassFoot";
import filebox from "@/components/Share/Preview/fileBox";
import { mapState, mapMutations } from "vuex";
import http from "@/utils/http";
export default {
  data() {
    return {
      paramInfo: {},
      invoiceInfo: {},
      fileInfo: {},
      tabconfig: {
        defaultValue: 0,
        backFun: this.tabClickBackFun,
        affixNum: 0,
        tabList: [
          { key: 0, value: "申请信息" },
          { key: 1, value: "审批信息" }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    }),
    detailTotal: function() {
      var amount=0;
      if(this.invoiceInfo.detailsList&&this.invoiceInfo.detailsList.length>0)
      {
         this.invoiceInfo.detailsList.forEach(element => {
           amount+=element.amount;
         });
      }
      return amount;
    }
  },
  methods: {
    ...mapMutations(["setTitleInfo"]),
    tabClickBackFun(index) {},
    getPurchaseInfo(applyId, applyTypeId) {
      let _this = this;
      this.$Spin.show();
      return new Promise((resolve, reject) => {
        http
          .get(
            `/api/FD/Invoice/GetInvoiceApplyInfo?applyId=${applyId}&applyTypeId=${applyTypeId}`
          )
          .then(res => {
            _this.$Spin.hide();
            if (res.data && res.data.data) {
              _this.setTitleInfo({
                title: "",
                bg: res.data.data.applyStatus,
                isMore: true
              });
              _this.fileInfo = {
                filesrcs: res.data.data.aTTUrl,
                filenames: res.data.data.aTTName
              };
              resolve(res.data.data || {});
            } else resolve({});
          });
      });
    }
  },
  async mounted() {
    let _this = this;
    this.$nextTick(() => {
      _this.tabconfig.affixNum = _this.$refs.tab.offsetTop - 1;
      _this.$refs.invoice_tab.style = "top:" + _this.tabconfig.affixNum + "px";
    });
    this.paramInfo = { ...this.$route.query };
    this.invoiceInfo = await this.getPurchaseInfo(
      this.paramInfo.applyId,
      this.paramInfo.applyTypeId
    );
  },
  components: {
    headers,
    tab,
    order,
    process,
    exefoot,
    selffoot,
    passfoot,
    filebox
  }
};
</script>
<style lang="less" scoped>
.invoice-box {
  .invoice-headers {
    padding: 0 0.4rem;
  }

  .invoice-tab {
    width: 100%;
    height: 1.44rem;
    position: sticky;
    z-index: 9;
    background: #fff;
    display: flex;
    align-items: center;
  }
  .mian-box {
    padding-bottom: 1.6rem;
    .invoice-info {
      .divide-line {
        margin-top: 0.4rem;
        width: 100%;
        height: 0.133333rem;
        background: #f5f5f5;
      }
      .invoice-content {
        padding: 0 0.4rem;
        .invoice-info-box {
          margin-top: 0.533333rem;
          font-size: 0.373333rem;
          display: flex;
          .invoice-info-label {
            text-align: center;
            flex: 1;
            color: #999;
          }
          .invoice-info-content {
            margin-left: 0.133333rem;
            width: 80%;
            color: #333333;
          }
        }
        .invoice-order {
          .invoice-order-label {
            height: 1.253333rem;
            line-height: 1.253333rem;
            font-size: 0.453333rem;
            color: #333333;
            font-weight: bold;
            border-bottom: 1px solid #eee;
          }
          .invoice-order-Total {
            height: 1.44rem;
            line-height: 1.44rem;
            font-size: 0.373333rem;
            color: #999999;
            padding-left: 0.4rem;
            span {
              color: #333333;
            }
          }
        }
      }
      .invoice-detail-content {
        padding: 0 0.4rem;
        .invoice-detail-title {
          height: 1.253333rem;
          line-height: 1.253333rem;
          font-size: 0.453333rem;
          color: #333333;
          font-weight: bold;
          border-bottom: 1px solid #eee;
        }
        .invoice-detail-Total {
          height: 1.44rem;
          line-height: 1.44rem;
          font-size: 0.373333rem;
          color: #999999;
          padding-left: 0.4rem;
          span {
            color: #333333;
          }
        }
      }
      .tab-box {
        border-bottom: 1px solid #eeeeee;
        border-right: 1px solid #eeeeee;
        margin-top: 0.5rem;
        .tab-box-item {
          display: flex;
          font-size: 0.373333rem;
          border-top: 1px solid #eeeeee;
          .tab-box-label {
            width: 2rem;
            min-height: 1.066667rem;
            color: #999;
            border-left: 1px solid #eeeeee;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .tab-box-value {
            flex: 1;
            min-height: 1.066667rem;
            border-left: 1px solid #eeeeee;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
    .process {
      margin-top: 0.4rem;
      padding: 0 0.4rem;
    }
  }
  .invoice-foot {
    padding: 0 0.4rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1.6rem;
    background: #fff;
    z-index: 9;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/FD/Invoice/index.vue